export default "__VITE_ASSET__Df13esu6__"